module.exports = __webpack_public_path__ + "static/media/editor_white.7bfac625.svg";